import mod from "-!./Comprar.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Comprar.js?vue&type=script&lang=js&"